import { Mutation } from 'vuex'
import { UserState } from '../types'

const setUserDisabledSoundNotifications: Mutation<UserState> = (
  state,
  payload: boolean
) => {
  state.disableSoundNotifications = payload
}

export default setUserDisabledSoundNotifications
